import React from "react";
import "./index.scss";

const SelfieModeButton = props => {
  const {src, name, onClick, isActive} = props;

  return (
    <div
      className={`selfie-mode-button ${
        isActive ? "selfie-mode-button--active" : ""
      } selfie-mode-button--${name}`}
      onClick={onClick}
    >
      <p className="selfie-mode-button-text">Selfie Mode</p>
      <img src={src} alt={name} />
    </div>
  );
};

export default SelfieModeButton;
